export const instructionsLeft = [
  { id: 1, value: 'byb.leftInstruction.first' },
  { id: 2 },
  { id: 3, value: 'byb.leftInstruction.third' },
];

export const instructionsRight = [
  { id: 1, value: 'byb.rightInstruction.first' },
  { id: 2, value: 'byb.rightInstruction.second' },
];
